import { EstimatedBuildingCostStateTypes, EstimatedBuildingCostActionTypes } from "./EstimatedBuildingCost.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: EstimatedBuildingCostStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const EstimatedBuildingCostReducer = (
  state: EstimatedBuildingCostStateTypes = INITIAL_STATE,
  action: any
): EstimatedBuildingCostStateTypes => {
  switch (action.type) {
    case EstimatedBuildingCostActionTypes.FETCH_ALL_ESTIMATED_BUILDING_COST:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case EstimatedBuildingCostActionTypes.FETCH_ALL_ESTIMATED_BUILDING_COST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EstimatedBuildingCostActionTypes.FETCH_ALL_ESTIMATED_BUILDING_COST_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EstimatedBuildingCostActionTypes.FETCH_ALL_ESTIMATED_BUILDING_COST_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case EstimatedBuildingCostActionTypes.FETCH_ONE_ESTIMATED_BUILDING_COST:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case EstimatedBuildingCostActionTypes.FETCH_ONE_ESTIMATED_BUILDING_COST_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case EstimatedBuildingCostActionTypes.FETCH_ONE_ESTIMATED_BUILDING_COST_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case EstimatedBuildingCostActionTypes.FETCH_ONE_ESTIMATED_BUILDING_COST_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default EstimatedBuildingCostReducer;
